const logsHeader = [
  {
    name: 'Username',
    sortable: true,
    selector: row => row.username,
    grow: 3,
  },
  {
    name: 'Event',
    sortable: true,
    selector: row => row.event,
    grow: 10,
  },
  {
    name: 'Date',
    sortable: true,
    selector: row => row.date ? new Date(row.date).toLocaleDateString() : '',
    grow: 2,
  },
  {
    name: 'IP address',
    sortable: true,
    selector: row => row.ip,
    grow: 2,
  },
  {
    name: 'Country',
    sortable: true,
    selector: row => row.country,
    grow: 2,
  },
  {
    name: 'Version',
    sortable: true,
    selector: row => row.version,
  },
]

export default logsHeader
